<template>
  <header style="padding-bottom: 20px;">
    <table style="width: 100%; font-size: 18px;">
      <tbody>
        <tr>
          <td style="width: 35%; text-align: right;">
            <div style="font-weight: bold; margin-bottom: 5px;">
              {{ systemSettings.system_name_ar || Lang.get('messages.site_name_ar') }}
            </div>
            <div style="font-size: 14px;">
              <p v-if="systemSettings.address" style="margin: 2px 0;">{{ Lang.get('messages.address') }}: {{ systemSettings.address }}</p>
              <p v-if="systemSettings.phone" style="margin: 2px 0;">{{ Lang.get('messages.phone') }}: {{ systemSettings.phone }}</p>
              <p v-if="systemSettings.email" style="margin: 2px 0;">{{ Lang.get('messages.email') }}: {{ systemSettings.email }}</p>
            </div>
          </td>
          <td style="text-align: center;">
            <img :src="systemSettings.system_logo_url || '/images/schoolna.png'" alt="System Logo" style="height: 100px;" />
          </td>
          <td style="width: 35%; text-align: left;">
            <div style="font-weight: bold; margin-bottom: 5px;">
              {{ systemSettings.system_name_en || Lang.get('messages.site_name_en') }}
            </div>
            <div style="font-size: 14px;">
              <p v-if="systemSettings.address" style="margin: 2px 0;">Address: {{ systemSettings.address }}</p>
              <p v-if="systemSettings.phone" style="margin: 2px 0;">Phone: {{ systemSettings.phone }}</p>
              <p v-if="systemSettings.email" style="margin: 2px 0;">Email: {{ systemSettings.email }}</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SystemPrintHeader",
  computed: {
    ...mapState("settings", ["settings"]),

    systemSettings() {
      return this.settings || {};
    },
    primaryColor() {
      return this.systemSettings.primary_color || '#1F5061';
    },
    secondaryColor() {
      return this.systemSettings.secondary_color || '#F05A28';
    }
  }
}
</script>

<style scoped>
</style>
